import React from 'react'
import { useSelector } from 'react-redux'
import { useNavigate, useParams } from 'react-router-dom'
import { GroupForm } from '../../../components/Templates/GroupForm'
import { useAppDispatch } from '../../../store'
import { updateGroup } from '../../../store/templatesNews/actions'
import { IGroupTemplate } from '../../../store/templatesTechSupport/types'
import { IStore } from '../../../store/types'
import { TypeTemplates } from '../../../utils/consts'
import { ROUTES } from '../../../utils/routes'

export const NewsEditGroup: React.FC = () => {
  const [group, setGroup] = React.useState<IGroupTemplate | null>(null)

  const { templatesNews } = useSelector((store: IStore) => store)
  const dispatch = useAppDispatch()
  const navigate = useNavigate()

  const { id } = useParams()

  React.useEffect(() => {
    if (templatesNews.groups) {
      const group = templatesNews.groups?.find((group) => group.absnum === Number(id))
      if (group) {
        setGroup(group)
      }
    }
  }, [templatesNews.groups, id])

  return (
    <GroupForm
      title={'Редагувати групу'}
      data={group}
      handleSubmit={(values, callback) => {
        if (!group) return null
        dispatch(updateGroup({ id: group.absnum, data: { ...values, is_type: TypeTemplates.NEWS } })).then((res) => {
          if (res.meta.requestStatus !== 'fulfilled') {
            callback(false)
          } else {
            navigate(ROUTES.templatesNews)
          }
        })
      }}
    />
  )
}
